module.exports = __webpack_public_path__ + "img/unionpay.a436c18a.svg";